import { decodeJwt } from 'jose';

export const isPiranhaToken = (token : string) => !!decodeJwt(token).tefUserAssets;
